import { render } from "./newCollegerejectedfundingmodel.vue?vue&type=template&id=95ef7644"
import script from "./newCollegerejectedfundingmodel.vue?vue&type=script&lang=js"
export * from "./newCollegerejectedfundingmodel.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/extra-storage/2026_cdf/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__